import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Dialog, DialogContent } from 'components/ui/dialog'
import {
	ONBOARDING_STEPS,
	initializeOnboarding,
	skipOnboarding,
} from 'slices/onboardingSlice'
import OnboardingProgress from './steps/OnboardingProgress'
import WelcomeStep from './steps/WelcomeStep'
import ProfileStep from './steps/ProfileStep'
import LocationStep from './steps/LocationStep'
import ProjectStep from './steps/ProjectStep'
import TaskTourStep from './steps/TaskTourStep'
import InviteStep from './steps/InviteStep'

const OnboardingFlow: React.FC = () => {
	const dispatch = useDispatch()

	const userLogin = useSelector((state: any) => state.userLogin)
	const { userInfo: user } = userLogin

	const onboarding = useSelector((state: any) => state.onboarding)
	const { currentStep, isOnboarding } = onboarding

	useEffect(() => {
		if (user) {
			dispatch(
				initializeOnboarding({
					step: user.onboardingStep || 0,
					isFirstTime: user.firstTime,
				}),
			)
		}
	}, [dispatch, user])

	if (!user || !isOnboarding) return null

	const handleSkipAll = () => {
		dispatch(skipOnboarding(user._id))
	}

	const renderStep = () => {
		switch (currentStep) {
			case ONBOARDING_STEPS.WELCOME:
				return <WelcomeStep userName={user.name} onSkip={handleSkipAll} />
			case ONBOARDING_STEPS.PROFILE:
				return <ProfileStep user={user} onSkip={handleSkipAll} />
			case ONBOARDING_STEPS.LOCATION:
				return <LocationStep user={user} onSkip={handleSkipAll} />
			case ONBOARDING_STEPS.PROJECT:
				return <ProjectStep user={user} onSkip={handleSkipAll} />
			case ONBOARDING_STEPS.TASK_TOUR:
				return <TaskTourStep user={user} onSkip={handleSkipAll} />
			case ONBOARDING_STEPS.INVITE:
				return <InviteStep user={user} onSkip={handleSkipAll} />
			default:
				return null
		}
	}

	// Don't close dialog on backdrop click during onboarding
	const handleClose = () => {
		// intentionally empty — user must use Skip or complete steps
	}

	return (
		<Dialog open={true} onClose={handleClose}>
			<DialogContent className="max-w-xl max-h-[90vh] overflow-y-auto">
				{currentStep > ONBOARDING_STEPS.WELCOME && (
					<div className="border-b border-gray-100">
						<OnboardingProgress currentStep={currentStep} />
					</div>
				)}
				{renderStep()}
			</DialogContent>
		</Dialog>
	)
}

export default OnboardingFlow
